import React from "react";

const Input = ({
  typeInput,
  textLabel,
  placeholder = "",
  name,
  value,
  className = "",
  onChange,
  required = false,
}) => {
  return (
    <label className="text-sm font-light flex items-center justify-between">
      <div className="flex">
        {textLabel} {required && <span className="text-red-500">*</span>}
      </div>
      <input
        type={`${typeInput}`}
        className={`appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal ${className}`}
        name={`${name}`}
        placeholder={`${placeholder}`}
        required={required}
        value={value}
        onChange={onChange}
      />
    </label>
  );
};

export default Input;
